import { TranslationKey } from "src/types/translationKey";

/**
 * The Payer IDs.
 * Defines the payer of the subscription.
 * - Used in the metadata of the purchase items.
 *    - "partner.payer": "79a815d6-262c-46e4-a20d-d942b79f8fee"
 * CASH_PAY = user pays with credit card
 * OTHER = users insurance or employer pays
 */
export enum PayerId {
  CASH_PAY = "79a815d6-262c-46e4-a20d-d942b79f8fee",
  TRANSCARENT = "9c201a22-bd05-41c8-b885-ab17b1c73330",
  EVERNORTH = "2c31438e-af1e-4401-a676-6925227992d2",
  GEORGIA = "3a437954-5990-4359-86e4-a4d877a012f6"
}

/**
 * Maps payer IDs to their additional legal text translation keys.
 * Add new payers here when they require custom legal text on checkout.
 */
export const PayerAdditionalLegalTextKey: Partial<
  Record<PayerId, TranslationKey>
> = {
  [PayerId.GEORGIA]: "signup.legalText_stateOfGeorgia"
};
